import React from "react"

export default function Footer() {
    return (
        <div className="Footer--container">
            <a href="https://github.com/zarqul" className="Footer--button"><i class="bi bi-github"></i></a>
        </div>
    )
}